import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Axios } from "../App";
import styles from "../styles/Counter.module.scss";
import Button from "@mui/material/Button";
import { useParams } from "react-router-dom";
import * as FaIcons from "react-icons/fa";

type TProps = {
  fontColor?: string;
};

const Counter = ({ fontColor }: TProps) => {
  const { id } = useParams();
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
  const [allGuests, setAllGuests] = useState<string | null>(null);
  const [allAdditionalGuests, setAllAdditionalGuests] = useState<string | null>(
    null
  );
  const [allParticipatedGuests, setAllParticipatedGuests] = useState<
    string | null
  >(null);
  const [allParticipatedAdditionalGuests, setAllParticipatedAdditionalGuests] =
    useState<string | null>(null);

  const getCounterDataByEventID = () => {
    Axios.post("participants/getCounterDataByEventID.php", {
      id: id,
    })
      .then(({ data }) => {
        setAllGuests(data.all_guests || 0);
        setAllAdditionalGuests(data.all_additional_guests || 0);
        setAllParticipatedGuests(data.all_participated_guests || 0);
        setAllParticipatedAdditionalGuests(
          data.all_participated_additional_guests || 0
        );
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const refresh = () => {
    setIsButtonDisabled(true);
    getQueries();
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 3000);
  };

  const getQueries = async () => {
    getCounterDataByEventID();
  };

  useEffect(() => {
    getQueries();
  }, []);

  return (
    <section className={styles.wrapper}>
      <Grid container spacing={2} justifyContent={"center"}>
        <Grid item xs={12} lg={8}>
          <Box sx={{ color: fontColor }}>Statisztika</Box>
        </Grid>
        <Grid item xs={12} lg={8}>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Összes jelenlévő</TableCell>
                  <TableCell>
                    Hozott vendégek száma
                  </TableCell>
                  <TableCell>Vártható összes hozott vendég</TableCell>
                  <TableCell>Összes várható vendég</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>{allParticipatedGuests}</TableCell>
                  <TableCell>
                    {allParticipatedAdditionalGuests}
                  </TableCell>
                  <TableCell>{allAdditionalGuests}</TableCell>
                  <TableCell>
                    {allGuests}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12} lg={8}>
          <Button
            disabled={isButtonDisabled}
            variant="contained"
            onClick={refresh}
          >
            <FaIcons.FaSync />
            &nbsp; Frissítés
          </Button>
        </Grid>
      </Grid>
    </section>
  );
};

export default React.memo(Counter);
